import React, { useEffect, useRef, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import ImpuestosTasasDatatable from './ImpuestosTasasDatatable'
import ImpuestosTasasForm from './ImpuestosTasasForm';
import { Toast } from "primereact/toast";
//context
import { usePresentacionContext } from '../context/presentacion.context';
//css
import './impuestosTasas.css'

const ImpuestosTasas = () => {
    const {onHideDialog,setOnHideDialog,showToastImpuestoTasaVerificado} = usePresentacionContext();
    const [position, setPosition] = useState('center');
    const toast = useRef<Toast>(null);

    useEffect(() => {
        if(showToastImpuestoTasaVerificado == -1 ) return
        toast.current?.show({life: 5000, severity: 'success', summary: 'Message', detail: 'Impuesto Verificado.'});
    }, [showToastImpuestoTasaVerificado])
    

    const onClickDisplay = (name:string, position:string) => {
        setOnHideDialog(true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = () => {
        setOnHideDialog(false)
    }

  return (
    <>
        <Toast ref={toast} position="bottom-right"/>
        <ImpuestosTasasDatatable onClick= {onClickDisplay} />
        <div className="dialog-demo">
            <Dialog className = "dialog-impuestos-tasas" header="DECLARACIÓN DE IMPUESTOS Y TASAS"  visible={onHideDialog}    onHide={() => onHide()}>
                <ImpuestosTasasForm/>
            </Dialog>
        </div>
    </>
  )
}

export default ImpuestosTasas